import React from 'react';
import { useTranslation } from 'react-i18next';
import './CadastroNaoRealizado.css';
import { useNavigate } from 'react-router-dom';

const CadastroNaoRealizado = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <div id="finalizacao" className="card bg-superficie elev5">
        <img
          alt={t('cadastro.accessibility.carol_image')}
          id="img-carol-boasvindas"
          src="/images/carol-perfil.png"
        />
        <br />
        <h1>{t('cadastro.messages.errors.registration_failed')}</h1>
        <p>
          {t('cadastro.messages.errors.cpf_validation')}
        </p>

        <button className="btn-pre" onClick={() => navigate('/login')}>
          {t('cadastro.accessibility.close')}
        </button>
      </div>
    </>
  );
};
export default CadastroNaoRealizado;
